import React from "react";
import { cn } from "../../../design-system/index.js";
import { Button, Card } from "../../../design-system/index.js";
import { Link } from "react-router-dom";
import { Users, HeartHandshake, Check, ArrowLeft } from "lucide-react";

const OPTIONS = [
  {
    type: "family",
    icon: Users,
    title: "Sou Família",
    tagline: "Quero contratar uma babá",
    description: "Quer acessar os serviços das babás profissionais da Tesourinhos? Preencha o cadastro como família.",
    bullets: ["Buscar e filtrar babás", "Contratar com segurança", "Gerenciar agendamentos"],
    href: "/profile-selection?type=family",
    accent: "var(--color-rose-400)",
    tintClass: "bg-[var(--color-rose-400)/15]",
    variant: "default",
  },
  {
    type: "babysitter",
    icon: HeartHandshake,
    title: "Sou Babá",
    tagline: "Quero oferecer meus serviços",
    description: "Quer se juntar à rede credenciada de babás verificadas da Tesourinhos? Cadastre-se como babá.",
    bullets: ["Criar perfil profissional", "Receber oportunidades", "Ser encontrada por famílias"],
    href: "/profile-selection?type=babysitter",
    accent: "var(--color-slate-blue-400)",
    tintClass: "bg-[var(--color-slate-blue-400)/15]",
    variant: "outline",
  },
];

export default function AuthOptionsPage() {
  return (
    <div className="min-h-screen flex items-center justify-center py-16">
      <div className="w-full max-w-4xl px-4">
        
        <div className="text-center mb-10">
          <h1 className={cn(
            "font-heading text-4xl font-bold",
            "text-warm-900 mb-3"
          )}>
            Como você quer usar o Tesourinhos?
          </h1>
          <p className="text-lg text-warm-600 max-w-2xl mx-auto">
            São dois cadastros diferentes. Escolha o que é a sua cara.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {OPTIONS.map((opt) => {
            const Icon = opt.icon;
            return (
              <Card
                key={opt.type}
                className="relative overflow-hidden p-6 pt-7 text-center transition-shadow hover:shadow-lg"
                style={{ borderTop: `4px solid ${opt.accent}` }}
              >
                <div className={cn(
                  "inline-flex items-center justify-center w-16 h-16 rounded-full mb-4",
                  opt.tintClass
                )}>
                  <Icon className="w-8 h-8" style={{ color: opt.accent }} strokeWidth={1.75} />
                </div>

                <h3 className="text-xl font-bold text-warm-900 mb-1">
                  {opt.title}
                </h3>
                <p className="text-sm font-semibold mb-3" style={{ color: opt.accent }}>
                  {opt.tagline}
                </p>
                <p className="text-sm text-warm-500 mb-5">
                  {opt.description}
                </p>

                <ul className="text-left space-y-2 mb-6 max-w-xs mx-auto">
                  {opt.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-warm-700 ">
                      <Check size={16} className="mt-0.5 shrink-0" style={{ color: opt.accent }} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <Button variant={opt.variant} className="w-full" asChild>
                  <a href={opt.href}>
                    Continuar como {opt.type === "family" ? "Família" : "Babá"}
                  </a>
                </Button>
              </Card>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-warm-500">
            Já tem uma conta?{" "}
            <a href="/login" className="font-semibold text-rose-400 hover:underline">
              Faça login
            </a>
          </p>

          <div className="mb-4 mt-8 flex justify-center items-center w-full">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/" aria-label="Voltar para a página principal" className="inline-flex items-center gap-2">
                <ArrowLeft size={14} />
                Voltar para a home
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
